import React, { useEffect } from 'react';
import { MenuComponent } from '../../../../rbts/assets/ts/components';
import { LoadingGrid, TableList } from '../../../../rbts/helpers';
import { useGetAllPuntosVenta } from '../hooks/StartShiftHook';

type Props = {
  reloadGrid: number;
  editRegister: (id: number) => void;
  removeRegister: (id: number) => void;
};

const ListadoPuntosVenta: React.FC<Props> = ({ reloadGrid, editRegister, removeRegister }) => {
  const { loadingRequest, shiftList } = useGetAllPuntosVenta(reloadGrid);

  const dropdownRender = (row: any) => {
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <div
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </div>
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <div
                className="menu-link px-3"
                onClick={() => {
                  editRegister(row.id);
                }}
              >
                Editar
              </div>
            </div>
            <div className="menu-item px-3">
              <div
                className="menu-link px-3 text-danger"
                onClick={() => {
                  removeRegister(row.id);
                }}
              >
                Borrar
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const columns: any = [
    {
      id: 'punto_venta',
      name: <div className="fw-bolder text-muted me-5">Punto de venta</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => (
        <>
          <span>{row.nombre}</span>
        </>
      ),
      sortable: true,
      width: '30%',
    },
    {
      id: 'split_banco',
      name: <div className="fw-bolder text-muted me-5">Split banco</div>,
      cell: (row: any) => row.convenioSplit ? <>{row.convenioSplit.porcentaje_banco} %</> : <span className="text-muted">-</span>,
      sortable: false,
      width: '20%',
    },
    {
      id: 'split_punto_venta',
      name: (
        <div className="fw-bolder text-muted me-5">Split punto de venta</div>
      ),
      cell: (row: any) => row.convenioSplit ? (
        <span className="">{row.convenioSplit.porcentaje_punto_venta} %</span>
      ) : (
        <span className="text-muted">-</span>
      ),
      sortable: false,
      width: '20%',
    },
    {
      id: 'productos',
      name: (
        <div className="fw-bolder text-muted me-5">Cantidad de productos:</div>
      ),
      cell: (row: any) => (
        <>
          <span className="">{row.productos.length}</span>
        </>
      ),
      sortable: false,
      width: '20%',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => (
        <>
          <>{dropdownRender(row)}</>
        </>
      ),
      sortable: false,
      width: '10%',
    },
  ];

  // useEffect(() => {
  MenuComponent.reinitialization();
  // }, [loadingRequest]);

  return loadingRequest ? (
    <LoadingGrid text="Cargando..."></LoadingGrid>
  ) : (
    <TableList data={shiftList} columns={columns} fillHeight></TableList>
  );
};

export { ListadoPuntosVenta };
